import { isBranchConstrained } from "../../auth/sessionAccess.ts";
import React from "react";
import { Partner } from "../../models/Partner";
import { useSelector } from "react-redux";
import { can } from "../../auth/can.ts";
import { RootState } from "../../store/index.ts";

const PROFILE_PANEL_TABS_STYLE_ID = "profile-panel-tabs-styles-v3";

const ProfileHeader = ({
  partner,
  activeTabId,
  onTabSelect,
}: {
  partner: Partner;
  activeTabId: string;
  onTabSelect: (tabId: string) => void;
}) => {
  const { user } = useSelector((state: RootState) => state.auth);

  const allTabs = [
    { id: "informacion", label: "Datos generales", icon: "fa-id-card", condition: true },
    {
      id: "expediente",
      label: "Expediente",
      icon: "fa-folder-open",
      condition: can("proceedings.view", user),
    },
    {
      id: "tracking",
      label: "Tracking",
      icon: "fa-route",
      condition: can("partners.view_imss_salary", user),
    },
    {
      id: "contrato",
      label: "Contratos",
      icon: "fa-file-contract",
      condition: can("contracts.view", user),
    },
    {
      id: "contratoIMSS",
      label: "Contrato IMSS",
      icon: "fa-file-medical",
      condition: can("partners.view_imss_salary", user),
    },
    { id: "empleo", label: "Datos del empleo", icon: "fa-briefcase", condition: true },
    {
      id: "movimientos",
      label: "Movimientos",
      icon: "fa-arrow-right-arrow-left",
      condition: !isBranchConstrained(user),
    },
  ];

  const visibleTabs = allTabs.filter((tab) => tab.condition);

  React.useEffect(() => {
    document.getElementById("profile-header-styles-v2")?.remove();
    document.getElementById("profile-header-styles-v3")?.remove();
    document.getElementById("profile-header-styles-v4")?.remove();
    document.getElementById("profile-header-styles-v5")?.remove();
    document.getElementById("profile-panel-tabs-styles")?.remove();
    document.getElementById("profile-panel-tabs-styles-v2")?.remove();
    if (document.getElementById(PROFILE_PANEL_TABS_STYLE_ID)) {
      return;
    }
    const styleSheet = document.createElement("style");
    styleSheet.id = PROFILE_PANEL_TABS_STYLE_ID;
    styleSheet.textContent = `
      .profile-partner-panel__head .nav-tabs {
        border-bottom: none !important;
        margin: 0 !important;
        padding: 0 4px !important;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        max-width: 100%;
      }
      .profile-partner-panel__head .nav-item {
        margin: 0 !important;
      }
      .profile-partner-panel__head .nav-link {
        border: none !important;
        border-bottom: 3px solid transparent !important;
        border-radius: 8px 8px 0 0 !important;
        margin: 0 !important;
        padding: 14px 18px !important;
        display: flex !important;
        align-items: center;
        gap: 8px;
        color: rgba(255, 255, 255, 0.65) !important;
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
        background: transparent !important;
        transition: color 0.15s ease, background 0.15s ease;
      }
      .profile-partner-panel__head .nav-link:hover {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.08) !important;
      }
      .profile-partner-panel__head .nav-link.active {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.12) !important;
        border-bottom: 3px solid #ffffff !important;
        font-weight: 600;
      }
      @media (max-width: 575.98px) {
        .profile-partner-panel__head .nav-link {
          padding: 12px 14px !important;
          font-size: 12px;
          gap: 6px;
        }
        .profile-partner-panel__head .nav-link span {
          max-width: 9rem;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    `;
    document.head.appendChild(styleSheet);
  }, []);

  if (!partner?.person) {
    return null;
  }

  return (
    <div className="profile-partner-panel__head">
      <ul className="nav nav-tabs" role="tablist">
        {visibleTabs.map((tab) => {
          const isActive = activeTabId === tab.id;
          return (
            <li className="nav-item" key={tab.id} role="presentation">
              <a
                href={`#${tab.id}`}
                className={`nav-link${isActive ? " active" : ""}`}
                role="tab"
                aria-selected={isActive}
                onClick={(e) => {
                  e.preventDefault();
                  onTabSelect(tab.id);
                }}
              >
                <i className={`fa-solid ${tab.icon}`} />
                <span>{tab.label}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ProfileHeader;
